import moment from 'moment';

import { TimelineItem } from '../../types/interfaces';

export const parseTime = (timeStr: string): { hours: number; minutes: number } => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return { hours, minutes };
};

export const getWorkHoursFromSchedule = (schedule: any): { start: number; end: number } | null => {
  if (!schedule) return null;
  
  const workdayStart = schedule.workdayStart;
  const workdayDuration = schedule.workdayDuration;
  
  if (!workdayStart || !workdayDuration) {
    return null;
  }
  
  const start = parseTime(workdayStart);
  const duration = parseTime(workdayDuration);
  
  const startMinutes = start.hours * 60 + start.minutes;
  const endMinutes = startMinutes + (duration.hours * 60 + duration.minutes);
  
  return { start: startMinutes, end: endMinutes };
};

export const createIntervalBackgrounds = (
  empId: number,
  dayMoment: moment.Moment,
  dateKey: string,
  workStartMinutes: number,
  workEndMinutes: number,
  intervalDurationHours: number
): TimelineItem[] => {
  const items: TimelineItem[] = [];
  const dayStart = dayMoment.startOf('day').valueOf();
  const dayEnd = dayMoment.endOf('day').valueOf();
  
  const workStart = dayStart + workStartMinutes * 60 * 1000;
  const workEnd = dayStart + workEndMinutes * 60 * 1000;
  const intervalMs = intervalDurationHours * 60 * 60 * 1000;
  
  items.push({
    id: `${empId}-bg-${dateKey}`,
    group: empId,
    title: '',
    start_time: dayStart,
    end_time: dayEnd,
    className: 'gray-background',
    itemProps: {
      style: {
        minHeight: 40,
        borderRadius: 4,
        opacity: 0.8,
        top: 0,
        backgroundColor: 'rgba(200, 200, 200, 0.3)',
      }
    }
  } as any);
  
  if (workStart > dayStart) {
    items.push({
      id: `${empId}-before-${dateKey}`,
      group: empId,
      title: '',
      start_time: dayStart,
      end_time: workStart,
      className: 'non-working-hours',
      itemProps: {
        style: {
          minHeight: 40,
          borderRadius: 4,
          opacity: 0.8,
          top: 0,
          backgroundColor: 'rgba(200, 200, 200, 0.15)',
        }
      }
    } as any);
  }
  
  let currentTime = workStart;
  let intervalIndex = 0;
  
  while (currentTime < workEnd) {
    const intervalEndTime = Math.min(currentTime + intervalMs, workEnd);
    const isWorkingInterval = intervalIndex % 2 === 0;
    
    items.push({
      id: `${empId}-interval-${dateKey}-${intervalIndex}`,
      group: empId,
      title: '',
      start_time: currentTime,
      end_time: intervalEndTime,
      className: isWorkingInterval ? 'interval-even' : 'interval-odd',
      itemProps: {
        style: {
          minHeight: 40,
          top: 0,
          zIndex: 2,
        }
      }
    } as any);
    
    currentTime = intervalEndTime;
    intervalIndex++;
  }
  
  if (workEnd < dayEnd) {
    items.push({
      id: `${empId}-after-${dateKey}`,
      group: empId,
      title: '',
      start_time: workEnd,
      end_time: dayEnd,
      className: 'non-working-hours',
      itemProps: {
        style: {
          minHeight: 40,
          borderRadius: 4,
          opacity: 0.8,
          top: 0,
        }
      }
    } as any);
  }
  
  return items;
};